import React from 'react'
import { BylineProps } from './Byline'
import { BylineProfile } from './components/BylineProfile'
import { BylineText } from './components/TheNightly/BylineText'
import { StyledByline } from './Byline.styled'
import { isContentPartner } from './helpers/isContentPartner'

export type TheNightlyBylineProps = Pick<
    BylineProps,
    | 'text'
    | 'isFullWidth'
    | 'profile'
    | 'source'
    | 'timestamp'
    | 'topic'
    | 'readTimeMinutes'
    | 'url'
> & {
    isLink?: boolean
    allowCommenting: boolean
}

export const TheNightlyByline: React.FC<TheNightlyBylineProps> = ({
    text,
    isFullWidth,
    profile,
    source,
    timestamp,
    topic,
    readTimeMinutes,
    url,
    isLink,
    allowCommenting,
}) => {
    return (
        <StyledByline isFullWidth={isFullWidth}>
            {profile && (
                <BylineProfile profile={profile} profilePageLink={isLink} />
            )}
            <BylineText
                text={text}
                profile={profile}
                source={source}
                timestamp={timestamp}
                topic={topic}
                readTimeMinutes={readTimeMinutes}
                isContentPartner={isContentPartner(source)}
                isLink={isLink}
                allowCommenting={allowCommenting}
                url={url}
            />
        </StyledByline>
    )
}
